<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="c"> <br class="calibre1"/></p>
</div>
<p class="western"> <br class="calibre1"/></p>
<p class="western1">Remains of the Dead</p>
<p class="western">Iain McKinnon</p>
<p class="western">Published by Permuted Press at
Smashwords.</p>
<p class="western">Copyright 2011 Iain McKinnon.</p>
<p class="western2"><span class="c1"><a href="http://www.PermutedPress.com/" target="_blank">www.PermutedPress.com</a></span></p>
<p class="western">Cover art by Craig Patton.</p>
<p class="western3"> <br class="calibre1"/></p>
<p class="western3"> <br class="calibre1"/></p>
<p class="c2"><img alt="tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ_html_m7d6faf32.jpg" class="calibre2" id="graphics1" src="tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ_html_m7d6faf32.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_585a07e3e5e55219dccf95a383be276f_OzNgdZ.ch.fixed.fc.tidied.stylehacked.xfixed_split_000.vue?a29e032c